import { FSharpRef, Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Role, Task_$reflection, EnrolledTrack_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, record_type, int32_type, bool_type, option_type, array_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { defaultArg, map, bind } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { map as map_2, equalsWith, tryFind, tryHead } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Task, Track } from "../ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { int32ToString, defaultOf as defaultOf_1, equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { singleton as singleton_1, ofArray, map as map_1 } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { Caption1Strong, Tab, TabList, Link, Caption1, Button, Tooltip, Subtitle2, CardHeader, Card, Caption2, Body1Strong, tokens, SkeletonItem, Skeleton } from "@fluentui/react-components";
import { rangeDouble } from "../fable_modules/fable-library-js.4.29.0/Range.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TrackProgressProps, TrackProgress, getTrackStats } from "./TrackProgress.jsx";
import { useCtx } from "../Context.jsx";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { ErrorCircleRegular, WeatherSunnyLowRegular, AddRegular, LayerDiagonalPersonRegular } from "@fluentui/react-icons";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { tryParse } from "../fable_modules/fable-library-js.4.29.0/Int32.js";
import { GrantTasksDialog } from "./GrantTasksDialog.jsx";

class Model extends Record {
    constructor(UserTracks, UserCompletedTasks, IsFetchingTracks, SelectedTrackId, IsGrantDialogOpen) {
        super();
        this.UserTracks = UserTracks;
        this.UserCompletedTasks = UserCompletedTasks;
        this.IsFetchingTracks = IsFetchingTracks;
        this.SelectedTrackId = SelectedTrackId;
        this.IsGrantDialogOpen = IsGrantDialogOpen;
    }
}

function Model_$reflection() {
    return record_type("Track.UserProgress.Model", [], Model, () => [["UserTracks", option_type(array_type(EnrolledTrack_$reflection()))], ["UserCompletedTasks", array_type(Task_$reflection())], ["IsFetchingTracks", bool_type], ["SelectedTrackId", option_type(int32_type)], ["IsGrantDialogOpen", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateUserTracks", "UpdateCompletedTasks", "UpdateIsFetching", "SelectTrack", "OpenGrantDialog", "CloseGrantDialog"];
    }
}

function Msg_$reflection() {
    return union_type("Track.UserProgress.Msg", [], Msg, () => [[["Item", option_type(array_type(EnrolledTrack_$reflection()))]], [["Item", array_type(Task_$reflection())]], [["Item", bool_type]], [["Item", int32_type]], [], []]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.UserTracks, msg.fields[0], model.IsFetchingTracks, model.SelectedTrackId, model.IsGrantDialogOpen);
        case 2:
            return new Model(model.UserTracks, model.UserCompletedTasks, msg.fields[0], model.SelectedTrackId, model.IsGrantDialogOpen);
        case 3:
            return new Model(model.UserTracks, model.UserCompletedTasks, model.IsFetchingTracks, msg.fields[0], model.IsGrantDialogOpen);
        case 4:
            return new Model(model.UserTracks, model.UserCompletedTasks, model.IsFetchingTracks, model.SelectedTrackId, true);
        case 5:
            return new Model(model.UserTracks, model.UserCompletedTasks, model.IsFetchingTracks, model.SelectedTrackId, false);
        default: {
            const tracks = msg.fields[0];
            return new Model(tracks, model.UserCompletedTasks, model.IsFetchingTracks, (model.SelectedTrackId == null) ? bind((arg) => map((_arg) => _arg.Track.Id, tryHead(arg)), tracks) : model.SelectedTrackId, model.IsGrantDialogOpen);
        }
    }
}

function init() {
    return new Model(undefined, [], true, undefined, false);
}

function Promises_fetchUserTracks(userId, dispatch) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            dispatch(new Msg(2, [false]));
        }
        else {
            dispatch(new Msg(0, [res.fields[0]]));
            dispatch(new Msg(2, [false]));
        }
    }, startAsPromise(Track.GetForUser(userId)));
    void (pr.catch((_arg) => {
        dispatch(new Msg(2, [false]));
    }));
}

function Promises_fetchMyTracks(dispatch) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            dispatch(new Msg(2, [false]));
        }
        else {
            dispatch(new Msg(0, [res.fields[0]]));
            dispatch(new Msg(2, [false]));
        }
    }, startAsPromise(Track.GetMy()));
    void (pr.catch((_arg) => {
        dispatch(new Msg(2, [false]));
    }));
}

function Promises_fetchCompletedTasks(userId, dispatch) {
    const pr = tap((res) => {
        if (res.tag === 0) {
            dispatch(new Msg(1, [res.fields[0]]));
        }
    }, startAsPromise(Task.GetForUser(userId)));
    void pr;
}

const skeleton = createElement("div", createObj(ofArray([["style", {
    display: "flex",
    gap: 15 + "px ",
}], (() => {
    const elems_1 = toList(delay(() => map_1((_arg) => {
        let elems, xs;
        const el_4 = Skeleton;
        return createElement(el_4, createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 15 + "px ",
        }], (elems = [(xs = toList(delay(() => {
            let el;
            return append(singleton((el = SkeletonItem, createElement(el, {
                style: {
                    width: 200,
                    height: 50,
                },
                animation: "wave",
                shape: "rectangle",
            }))), delay(() => map_1((_arg_1) => {
                const el_2 = SkeletonItem;
                return createElement(el_2, {
                    style: {
                        width: 175,
                        height: 50,
                    },
                    animation: "wave",
                    shape: "rectangle",
                });
            }, toList(rangeDouble(1, 1, 4)))));
        })), react.createElement(react.Fragment, {}, ...xs))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, toList(rangeDouble(1, 1, 4)))));
    return ["children", reactApi_1.Children.toArray(Array.from(elems_1))];
})()])));

function progressRing(pct, size, strokeWidth) {
    let elems;
    const r = (size - strokeWidth) / 2;
    const c = (2 * 3.141592653589793) * r;
    const offset = c * (1 - (pct / 100));
    const half = size / 2;
    return createElement("div", createObj(ofArray([["style", {
        width: size,
        height: size,
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    }], (elems = [createElement("div", {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
        dangerouslySetInnerHTML: {
            __html: `
                    <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
                        <circle cx="${half}" cy="${half}" r="${r}" fill="none" stroke="${tokens.colorNeutralStroke2}" stroke-width="${strokeWidth}" />
                        <circle cx="${half}" cy="${half}" r="${r}" fill="none" stroke="${tokens.colorBrandBackground}" stroke-width="${strokeWidth}"
                            stroke-dasharray="${c}" stroke-dashoffset="${offset}" stroke-linecap="round"
                            transform="rotate(-90 ${half} ${half})" style="transition: stroke-dashoffset .3s" />
                    </svg>
                `,
        },
    }), createElement("span", {
        style: {
            position: "relative",
            fontSize: ((size >= 40) ? 11 : 9) + "px",
            fontWeight: 600,
            color: tokens.colorNeutralForeground1,
        },
        children: `${pct}%`,
    })], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

function trackTabContent(track, completedTasks) {
    let elems_1, elems, el, el_2;
    const stats = getTrackStats(track, completedTasks);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
    }], (elems_1 = [progressRing(stats.Percentage, 36, 3), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
    }], (elems = [(el = Body1Strong, createElement(el, {
        children: track.Track.Name,
    })), (el_2 = Caption2, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground2,
        },
        children: `${stats.CompletedLevels}/${stats.TotalLevels} nivåer · ${stats.CompletedTasks}/${stats.TotalTasks} oppgaver`,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
}

export function TrackProgressCard(user) {
    let elems_8, el_10, el, el_2, el_8, el_6, el_4, elems_7;
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi_1.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const ctx = useCtx()[0];
    const viewingSelf = ctx.User.Id === user.Id;
    const canGrantTasks = equals(ctx.User.Role, new Role(1, [])) && !viewingSelf;
    useEffectOnce(() => {
        if (viewingSelf) {
            Promises_fetchMyTracks(dispatch);
        }
        else {
            Promises_fetchUserTracks(user.Id, dispatch);
        }
        Promises_fetchCompletedTasks(user.Id, dispatch);
    });
    const selectedTrack = bind((tracks) => bind((id) => tryFind((t) => (t.Track.Id === id), tracks), model_1.SelectedTrackId), model_1.UserTracks);
    const el_38 = Card;
    return createElement(el_38, createObj(ofArray([["style", {
        minHeight: 25 + "vh",
    }], (elems_8 = [(el_10 = CardHeader, createElement(el_10, {
        image: (el = LayerDiagonalPersonRegular, createElement(el, {
            fontSize: 32,
        })),
        header: (el_2 = Subtitle2, createElement(el_2, {
            children: "Fremdrift",
        })),
        description: "Oversikt over fremdrift i dine læringsløp",
        action: (canGrantTasks && (selectedTrack != null)) ? ((el_8 = Tooltip, createElement(el_8, {
            content: "For å fjerne tidligere fullføringer, gå til historikk.",
            relationship: "label",
            children: (el_6 = Button, createElement(el_6, {
                appearance: "primary",
                icon: (el_4 = AddRegular, createElement(el_4, {})),
                children: "Tildel oppgaver",
                onClick: (_arg_1) => {
                    dispatch(new Msg(4, []));
                },
            })),
        }))) : defaultOf(),
    })), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 16 + "px ",
        padding: 16,
    }], (elems_7 = toList(delay(() => {
        let matchValue, testExpr, elems_2, userTracks, el_28, elems_4, elems, el_12, el_14;
        return append(model_1.IsFetchingTracks ? singleton(skeleton) : ((matchValue = model_1.UserTracks, (matchValue != null) ? (((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf_1()) && (testExpr.length === 0))) ? singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 5 + "px ",
            padding: 15,
        }], (elems_2 = toList(delay(() => {
            let el_16;
            return append(singleton((el_16 = WeatherSunnyLowRegular, createElement(el_16, {
                primaryFill: tokens.colorBrandForeground1,
                style: {
                    fontSize: 96 + "px",
                },
            }))), delay(() => {
                let el_18, el_24;
                return viewingSelf ? append(singleton((el_18 = Caption1, createElement(el_18, {
                    children: "Du er ikke påmeldt noen læringsløp",
                }))), delay(() => {
                    let el_22, elems_1, el_20;
                    return singleton((el_22 = Link, createElement(el_22, createObj(ofArray([["href", RouterModule_encodeParts(singleton_1("laeringslop"), 1)], (elems_1 = [(el_20 = Button, createElement(el_20, {
                        size: "small",
                        children: "Se alle læringsløp",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))));
                })) : singleton((el_24 = Caption1, createElement(el_24, {
                    children: `${user.FirstName} ${user.LastName} er ikke påmeldt noen læringsløp`,
                })));
            }));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))) : ((userTracks = matchValue, append(singleton((el_28 = TabList, createElement(el_28, createObj(ofArray([["selectedValue", defaultArg(map(int32ToString, model_1.SelectedTrackId), "")], ["onTabSelect", (_arg_2, value_1_14) => {
            let matchValue_1;
            let outArg = 0;
            matchValue_1 = [tryParse(value_1_14.value, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                outArg = (v | 0);
            })), outArg];
            if (matchValue_1[0]) {
                dispatch(new Msg(3, [matchValue_1[1]]));
            }
        }], (elems_4 = toList(delay(() => map_2((track) => {
            let elems_3;
            const el_26 = Tab;
            return createElement(el_26, createObj(ofArray([["value", int32ToString(track.Track.Id)], (elems_3 = [trackTabContent(track, model_1.UserCompletedTasks)], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
        }, userTracks))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))), delay(() => {
            let elems_6;
            const matchValue_2 = selectedTrack;
            if (matchValue_2 == null) {
                return empty();
            }
            else {
                const track_1 = matchValue_2;
                const stats = getTrackStats(track_1, model_1.UserCompletedTasks);
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 12 + "px ",
                    paddingTop: 8,
                }], (elems_6 = toList(delay(() => {
                    let elems_5, el_30, el_32, el_34, el_36;
                    const matchValue_3 = stats.CurrentLevel;
                    if (matchValue_3 == null) {
                        return singleton(defaultOf());
                    }
                    else {
                        const level = matchValue_3;
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 4 + "px ",
                        }], (elems_5 = [(el_30 = Caption1, createElement(el_30, {
                            children: viewingSelf ? "Du er på" : "Bruker er på",
                        })), (el_32 = Caption1Strong, createElement(el_32, {
                            children: `Nivå ${level.Order}`,
                        })), (el_34 = Caption1, createElement(el_34, {
                            children: "—",
                        })), (el_36 = Caption1Strong, createElement(el_36, {
                            children: `«${level.Name}»`,
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))));
                    }
                })), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))), delay(() => singleton(createElement(TrackProgress, new TrackProgressProps(track_1, model_1.UserCompletedTasks, undefined, undefined, false)))));
            }
        }))))) : singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 5 + "px ",
            padding: 15,
        }], (elems = [(el_12 = ErrorCircleRegular, createElement(el_12, {
            primaryFill: tokens.colorBrandForeground1,
            style: {
                fontSize: 96 + "px",
            },
        })), (el_14 = Caption1, createElement(el_14, {
            children: "Kunne ikke hente kursløp for bruker. Vennligst prøv igjen senere",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))))), delay(() => {
            let tracks_1;
            if (canGrantTasks) {
                const matchValue_4 = model_1.UserTracks;
                let matchResult, tracks_2;
                if (matchValue_4 != null) {
                    if ((tracks_1 = matchValue_4, tracks_1.length > 0)) {
                        matchResult = 0;
                        tracks_2 = matchValue_4;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return singleton(createElement(GrantTasksDialog, {
                            user: user,
                            userTracks: tracks_2,
                            completedTasks: model_1.UserCompletedTasks,
                            isOpen: model_1.IsGrantDialogOpen,
                            onClose: () => {
                                dispatch(new Msg(5, []));
                            },
                            onSaved: (updatedTasks) => {
                                dispatch(new Msg(1, [updatedTasks]));
                                Promises_fetchUserTracks(user.Id, dispatch);
                            },
                        }));
                    default: {
                        return empty();
                    }
                }
            }
            else {
                return empty();
            }
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

//# sourceMappingURL=UserProgress.jsx.map
